import React from 'react'
import * as CC from '@chakra-ui/react'

const SkeletonBoardPreviewCard: React.FC = () => {
    return (
        <CC.Box>
            <CC.Grid
                h={'auto'}
                templateColumns={{ sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }}
                gap={3}
            >
                <CC.GridItem
                    rowSpan={2}
                    colSpan={2}
                    rounded={'xl'}
                    minWidth='9rem'
                    minHeight={'15.25rem'}
                >
                    <CC.Skeleton height={'100%'} width={'100%'} rounded='xl' />
                </CC.GridItem>

                <CC.GridItem colSpan={1} rounded={'xl'} minWidth={'7.25rem'} aspectRatio={'1/1'}>
                    <CC.Skeleton height={'100%'} width={'100%'} rounded='xl' />
                </CC.GridItem>

                <CC.GridItem colSpan={1} rounded={'xl'} minWidth={'7.25rem'} aspectRatio={'1/1'}>
                    <CC.Skeleton height={'100%'} width={'100%'} rounded='xl' />
                </CC.GridItem>
            </CC.Grid>
            <CC.VStack spacing={'sm'} mt={4} align='stretch'>
                <CC.HStack spacing={2}>
                    <CC.SkeletonText noOfLines={2} spacing='4' skeletonHeight='2' width='100%' />
                </CC.HStack>
            </CC.VStack>
        </CC.Box>
    )
}
export default SkeletonBoardPreviewCard
